import { render } from "./ProblemInfoLabel.vue?vue&type=template&id=fac8ec3a&ts=true"
import script from "./ProblemInfoLabel.vue?vue&type=script&lang=ts"
export * from "./ProblemInfoLabel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__